import { render, staticRenderFns } from "./project-power-plant.vue?vue&type=template&id=119629ae"
import script from "./project-power-plant.vue?vue&type=script&lang=js"
export * from "./project-power-plant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports